import { cn } from '@sohanemon/utils';
import { Iconify } from '@sohanemon/utils/components';
import { m } from '@sohanscript/i18n';
import type { ComponentProps } from 'react';
import { Link } from '@/components/link';

type PageNavProps = ComponentProps<'nav'> & {
	currentSlug: string;
	itemTo: string;
	listTo: string;
	listLabel: string;
	items: Array<{ slug: string; title: string }>;
};

export function PageNav({
	currentSlug,
	itemTo,
	listTo,
	listLabel,
	items,
	className,
	...props
}: PageNavProps) {
	const currentIndex = items.findIndex((p) => p.slug === currentSlug);
	const prev = currentIndex > 0 ? items[currentIndex - 1] : null;
	const next = currentIndex < items.length - 1 ? items[currentIndex + 1] : null;

	return (
		<nav
			className={cn('flex items-center justify-between gap-10', className)}
			{...props}
		>
			{prev ? (
				<Link
					to={itemTo as '/'}
					params={{ slug: prev.slug } as never}
					viewTransition={{ types: ['slide-right'] }}
					className="group flex items-center gap-2 text-primary/60 text-sm transition-colors hover:text-primary"
				>
					<Iconify
						icon="solar:arrow-left-linear"
						className="size-4 transition-transform group-hover:-translate-x-1 rtl:-scale-x-100 rtl:group-hover:translate-x-1"
					/>
					<span className="line-clamp-2">
						{m.page_prev({ title: prev.title })}
					</span>
				</Link>
			) : (
				<Link
					to={listTo as '/'}
					className="flex items-center gap-1 text-primary/60 text-sm transition-colors hover:text-primary"
				>
					<Iconify
						icon="solar:arrow-left-linear"
						className="size-4 rtl:-scale-x-100"
					/>
					{listLabel}
				</Link>
			)}

			{next ? (
				<Link
					to={itemTo as '/'}
					viewTransition={{ types: ['slide-left'] }}
					params={{ slug: next.slug } as never}
					className="group flex items-center gap-2 text-primary/60 text-sm transition-colors hover:text-primary"
				>
					<span className="line-clamp-2">
						{m.page_next({ title: next.title })}
					</span>
					<Iconify
						icon="solar:arrow-right-linear"
						className="size-4 transition-transform group-hover:translate-x-1 rtl:-scale-x-100 rtl:group-hover:-translate-x-1"
					/>
				</Link>
			) : (
				<span />
			)}
		</nav>
	);
}
